import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PublicBoxQuestionnaireSummaryResponse {
  @jsonMember(Number)
  public readonly notShown!: number;
}
